import { useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { DEFAULT_LANGUAGE } from 'shared/constants/Languages'
import { useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const DocAiApp = () => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  const selectedLanguage = useMemo(
    () => i18n.language ?? DEFAULT_LANGUAGE,
    [i18n.language]
  )

  return (
    <FullPageAppTemplate
      appId={AppId.DOC_AI}
      scope='doc_ai'
      envKey={apps[AppId.DOC_AI].runtimeEnvKey}
      entryPath='./DocAIApp'
      url={process.env.REACT_APP_DOC_AI_APP_DEV_PATH}
      appName={apps[AppId.DOC_AI].name}
      appProps={{
        user,
        history,
        selectedLanguage,
        appPath: apps[AppId.DOC_AI].path,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
